import React, { useEffect, useState } from 'react'
import { List } from 'semantic-ui-react'
import axios from 'axios'
import { useUIState, useUIDispatch } from '../context/store';

function SubSub() {
    const dispatch = useUIDispatch();
    const [list, setList] = useState({});
    const [active, setActive] = useState('all');
    const { query } = useUIState();

    const handleClick = (e, data) => {
        const { wp_rest } = window.theme_vars;
        const endpoint = `${wp_rest}social/v1/orders`;
        const filterBy = e.target.getAttribute('data-name');
        let payload  = {...query, filterBy, page: 1};
        dispatch({type:'TOGGLE_LOADER'});

        if('all'===filterBy) {
            delete query.filterBy;
            payload = query;
        } 

        dispatch({type: 'SET_QUERY', payload});

        axios.get(endpoint, {
            params: payload
        }).then(resp => {
            dispatch({
                type: 'STORE_ORDERS',
                payload: resp.data
            });
            setTimeout(()=>dispatch({type:'TOGGLE_LOADER'}), 1800);
        })

        setActive(filterBy.toLowerCase());
    }

    useEffect(() => {
        const { wp_rest } = window.theme_vars;
        const endpoint = `${wp_rest}social/v1/subsub`;
        axios.get(endpoint).then(resp => {
            // console.log(resp.data)
            setList(resp.data);
        });
    }, [])

    return (
        <List divided horizontal className="subsubsub">
            <List.Item 
                className={'all'===active ? 'active' : ''}
                data-name='all'
                onClick={'all'===active ? ()=>console.log('dormant') : handleClick}
            >
                All (0)
            </List.Item>
            {list && Object.entries(list).map(([x,{name, count}], i) => <List.Item 
                key={i}
                className={name.toLowerCase()===active ? 'active' : ''}
                data-name={name}
                onClick={name.toLowerCase()===active ? ()=>console.log('dormant') : handleClick}
            >
                {name} ({count})
            </List.Item>)}
        </List>
    )
}

export default SubSub
